import { render, staticRenderFns } from "./SurveyStep4.vue?vue&type=template&id=6ac4daae&scoped=true&"
import script from "./SurveyStep4.vue?vue&type=script&lang=js&"
export * from "./SurveyStep4.vue?vue&type=script&lang=js&"
import style0 from "./SurveyStep4.vue?vue&type=style&index=0&id=6ac4daae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac4daae",
  null
  
)

export default component.exports